import APICreator from "unspoken-core/lib/api/Api";

const API = APICreator({
  apiKey: process.env.REACT_APP_BACKEND_APIKEY || '',
  domain: process.env.REACT_APP_BACKEND_AUTHDOMAIN || '',
  projectId: process.env.REACT_APP_BACKEND_PROJECTID || '',
  storageBucket: process.env.REACT_APP_BACKEND_STORAGEBUCKET || '',
}).API;

// Instantiate the API
export default API;



// WEBPACK FOOTER //
// ./src/Api.tsx